export default __webpack_public_path__ + "static/media/discord.f1174c8c.png";